// extracted by mini-css-extract-plugin
export default {"container":"Qj-z","links":"Rj-z"};